import Image from 'next/image';

import { DEFAULT_AVATAR } from '@/features/v2/constants/avatars/avatars';
import { DIANA_AVATAR } from '@/features/v2/constants/avatars/diana';

const Avatar = () => {
  return (
    <div>
      <div className="relative mt-1 -ml-3.5 h-[47px] w-[50px] rounded-full">
        <Image
          src={DIANA_AVATAR}
          alt="frame"
          width={50}
          height={50}
          className="absolute inset-0 object-cover h-[50px] w-[50px] z-10 rounded-full pointer-events-none"
          loading="lazy"
          quality={70}
          draggable={false}
        />
        <div className="relative overflow-hidden h-full w-full rounded-full z-[1]">
          <Image
            src={DEFAULT_AVATAR}
            alt="avatar"
            width={100}
            height={100}
            className="object-cover object-top h-[130px] w-[130px] rounded-full scale-95 mt-1.5 z-0"
            style={{ transformOrigin: 'top center' }}
            loading="lazy"
            quality={70}
            draggable={false}
          />
        </div>
      </div>
    </div>
  );
};

export default Avatar;
